import "./style.scss";

import { Skeleton } from "@mui/material";

export const LIST_SKELETON_COUNT = 8;

type TextSkeletonProps = {
    width?: number | string;
    height?: number | string;
    variant?: "text" | "circular" | "rounded";
    className?: string;
};

/**
 * Neutral placeholder that inherits the parent font size for text,
 * so it sits in the same layout as the real value.
 */
const TextSkeleton = ({ width = "8em", height, variant = "text", className }: TextSkeletonProps) => (
    <Skeleton
        variant={variant}
        animation="wave"
        width={width}
        height={height}
        className={`text-skeleton${className ? ` ${className}` : ""}`}
    />
);

export default TextSkeleton;
